import axios, { resHandle } from "@/plugins/axios";

/**
 * @description 获取面图数据
 */

const GetMian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/faces", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 保存面图数据
 */

const SaveMian = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/patient/face", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 获取手图数据
 */

const GetShou = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/hands", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 保存手图数据
 */

const SaveShou = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/patient/hand", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 获取发图数据
 */

const GetFa = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/patient/hairs", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 保存发图数据
 */

const SaveFa = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/zwb/patient/hair", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};


/**
 * @description 专病库列表
 * @param vCom Vue组件
 */
const GetCenter = (vCom: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/list").then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 机构列表页
 * @param vCom Vue组件
 */
const InstitutionList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/user/institutions", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};


/**
 * @description 创建人列表
 * @param vCom Vue组件
 */
const CreatorList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/creators", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 患者列表页
 * @param vCom Vue组件
 */
const PatientList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/yjdl/patients", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 患者详情
 * @param vCom Vue组件
 */
const PatientDetail = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 研究队列高级筛选：研究指标列表
 * @param vCom Vue组件
 * @param projectId project_id
 * @param groupId group_id
 */
const GetTemplatesOfGroup = (vCom: any, projectId: string, groupId: any): Promise<any> => {
    const params: any = {
        params: {
            project_id: projectId,
            group_id: groupId
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project/yjdl/search/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 研究队列高级筛选：研究指标各个题目信息
 * @param vCom Vue组件
 * @param templateId template_id
 */
const GetTopicsOfTemplate = (vCom: any, templateId: string): Promise<any> => {
    const params: any = {
        params: {
            template_id: templateId,
        }
    };
    return new Promise((resolve, reject) => {
        axios.get("api/project/yjdl/search/topics", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 添加患者
 * @param vCom Vue组件
 */
const CreatePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 人口信息学模板
 * @param vCom Vue组件
 */
const GetRenkouxueTemplate = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/app/common/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 人口信息学详情
 * @param vCom Vue组件
 */
const GetRenkouxueContent = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/app/common/content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 上传人口学信息
 * @param vCom Vue组件
 */
const ChangeRenkouxueContent = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 编辑患者
 * @param vCom Vue组件
 */
const ComposePatient = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.put("api/project/patient", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 诊次列表
 * @param vCom Vue组件
 */
const GetZhenciList = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/zhencis", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 添加诊次
 * @param vCom Vue组件
 */
const AddZhenci = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/zhenci", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 添加诊次
 * @param vCom Vue组件
 */
const DeleteZhenci = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.delete("api/project/zhenci", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 患者详情左侧-左侧导航栏
 * @param vCom Vue组件
 */
const LeftInterviews = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/yjdl/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 获取患者某部分信息
 * @param vCom Vue组件
 */
const GetPatientPartDetail = (vCom: any, patientId: string, part: string): Promise<any> => {
    return new Promise((resolve, reject) => {
        const params: any = {
            params: {
                patient_id: patientId
            }
        };
        const requestUrl: any = {
            个人信息: "api/zwb/patient/info",
            健康史: "api/zwb/patient/info",
            舌象基础: "api/zwb/patient/tongues",
            舌象科研: "api/zwb/patient/research/tongues",
            舌图报告: "api/zwb/patient/research/tongues2",
            面象数据: "api/zwb/patient/faces",
            脉象数据: "api/zwb/patient/pulses",
            发图数据: "api/zwb/patient/hairs",
            手图数据: "api/zwb/patient/hands",
            中医体质: "api/zwb/patient/nines",
            四诊合参: "api/zwb/patient/tcms",
            儿童版: "api/zwb/patient/chds",
            老年版: "api/zwb/patient/olds",
            备孕女性: "api/zwb/patient/prepres",
            孕期女性: "api/zwb/patient/pres",
            产后女性: "api/zwb/patient/partums",
            围绝经期女性: "api/zwb/patient/wjjqs",
            高血压: "api/zwb/patient/hyps",
            糖尿病: "api/zwb/patient/dias",
            中医心理测评: "api/zwb/patient/phys"
        };
        axios.get(requestUrl[part], params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 获取舌图数据
 * @param vCom Vue组件
 */
const GetShetushuju = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/zwb/zhenci/ai/tongue", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 模板详情
 * @param vCom Vue组件
 */
const GetTemplates = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/template", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 数据详情
 * @param vCom Vue组件
 */
const GetContents = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};


/**
 * @description 数据采集：编辑、创建数据
 * @param vCom Vue组件
 * @param params 参数
 */
const PostContents = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/project/content", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err: any) => {
                reject(err);
            });
        }).catch((err: any) => {
            reject(err);
        });
    });
};

const UploadImage = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/image", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

const UploadVideo = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/upload/file", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};


/**
 * @description 数据导出：列研究指标（数据导出第二步页面）
 * @param vCom Vue组件
 */
const GetDataExportTemplates = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/center/export/column/templates", params).then(({ data }) => {
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

/**
 * @description 数据导出
 * @param vCom Vue组件
 */
const PostDataExport = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.post("api/center/export/lincenter", params).then(({ data }) => {
            resolve(data);
            // resHandle(vCom, data).then(() => {
            //     resolve(data.data);
            // }).catch((err) => {
            //     reject(err);
            // });
        }).catch((err) => {
            reject(err);
        });
    });
};
/**
 * @description 诊次数据导出
 * @param vCom Vue组件
 */
const ExportZhenciData = (vCom: any, params: any): Promise<any> => {
    return new Promise((resolve, reject) => {
        axios.get("api/project/report", params).then(({ data }) => {
            resolve(data.data);
            resHandle(vCom, data).then(() => {
                resolve(data.data);
            }).catch((err) => {
                reject(err);
            });
        }).catch((err) => {
            reject(err);
        });
    });
};

export {
    GetCenter, InstitutionList, CreatorList, PatientList, PatientDetail, GetTemplatesOfGroup, GetTopicsOfTemplate,
    CreatePatient, GetRenkouxueTemplate, GetRenkouxueContent, ChangeRenkouxueContent, ComposePatient,
    GetZhenciList, AddZhenci, DeleteZhenci, LeftInterviews, GetPatientPartDetail, GetTemplates, GetContents, PostContents,
    UploadImage, UploadVideo, GetShetushuju,
    GetDataExportTemplates, PostDataExport, GetMian, SaveMian, GetShou, SaveShou, GetFa, SaveFa, ExportZhenciData
};
